import { render, staticRenderFns } from "./DNHeader.vue?vue&type=template&id=67c8fd70"
import script from "./DNHeader.vue?vue&type=script&lang=js"
export * from "./DNHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports